<!-- TEMPLATE -->
<template>
  <div class="dean-table">
    <div class="view-buttons" v-if="showLayoutButtons">
      <dean-icon
        :class="viewButton(!gridView)"
        :glyph="summeryIcon"
        @click.native="gridView = false"
      ></dean-icon>
      <dean-icon
        :class="viewButton(gridView)"
        :glyph="gridIcon"
        @click.native="gridView = true"
      ></dean-icon>
    </div>
    <div class="no-data" v-if="checkTableData(tableData)">
      <p class="no-data-text">Geen resultaten...</p>
      <dean-icon class="no-data-icon" :glyph="archiveIcon"> </dean-icon>
    </div>
    <div v-else :class="view">
      <table>
        <thead>
          <tr>
            <th
              v-for="(column, key) in columns"
              :key="key"
              :align="column.align"
            >
              <span
                class="sort"
                v-if="checkColumnType(column.sort)"
                @click="deanTableColumnClick(column)"
              >
                <span>{{ column.content }}</span>
                <span :class="deanTableColumnSort(column)"></span>
              </span>
              <span v-else>
                <span>{{ column.content }}</span>
                <span class="arrow-empty"></span>
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(row, key) in tableData"
            :key="key"
            :class="trClass(row)"
            @click="deanTableRowClick(data[key])"
          >
            <td
              v-for="(cell, key) in row"
              :key="key"
              @click="deanTableCellClick(cell, key)"
              :data-label="cell.title"
              :align="cell.align"
            >
              <!-- CHECK IF ITEM IS OBJECT -->
              <span v-if="typeof cell === 'object'">
                <span
                  v-if="checkRowType(cell.type) && checkIfHeader(row) == true"
                >
                  {{ cell.content }}
                </span>

                <!-- CHECK IF OBJECT TYPE IS UNDEFINED -->
                <span v-else-if="checkRowType(cell.type)">
                  {{ cell.content }}
                </span>

                <!-- CHECK IF OBJECT TYPE IS SLOT -->
                <span :class="cell.align" v-if="cell.type == 'slot'">
                  <slot :name="cell.slot" :value="cell"></slot>
                </span>
                <span>
                  <!-- CHECK IF OBJECT TYPE IS LINK -->
                  <span v-if="cell.type == 'link'">
                    <span class="link wrap">{{ cell.content }}</span>
                  </span>

                  <!-- CHECK IF OBJECT TYPE IS TOOLTIP -->
                  <dean-tooltip v-if="cell.type == 'tooltip'">
                    <a class="link wrap" slot="activator">
                      {{ cell.content }}
                    </a>
                    {{ cell.tooltip }}
                  </dean-tooltip>

                  <!-- CHECK IF OBJECT TYPE IS ICON -->
                  <span v-if="cell.type == 'icon'">
                    <dean-tooltip v-if="cell.tooltip">
                      <span slot="activator">
                        <dean-table-item
                          class="wrap"
                          :glyph="cell.icon"
                          :align="cell.align"
                        >
                          {{ cell.content }}
                        </dean-table-item>
                      </span>
                      {{ cell.tooltip }}
                    </dean-tooltip>
                    <dean-table-item
                      v-else
                      class="wrap"
                      :glyph="cell.icon"
                      :align="cell.align"
                    >
                      {{ cell.content }}
                    </dean-table-item>
                  </span>

                  <!-- CHECK IF OBJECT TYPE IS ICON LINK-->
                  <span v-if="cell.type === 'icon-link'">
                    <dean-tooltip v-if="cell.tooltip">
                      <a slot="activator">
                        <dean-table-item
                          class="wrap"
                          :glyph="cell.icon"
                          :align="cell.align"
                          :link="true"
                        >
                          {{ cell.content }}
                        </dean-table-item>
                      </a>
                      {{ cell.tooltip }}
                    </dean-tooltip>
                    <dean-table-item
                      v-else
                      class="wrap"
                      :glyph="cell.icon"
                      :align="cell.align"
                      :link="true"
                    >
                      {{ cell.content }}
                    </dean-table-item>
                  </span>

                  <!-- CHECK IF OBJECT CONTENT IS UNDEFINED -->
                  <span
                    class="empty-cell"
                    v-if="
                      cell.type != 'currency' &&
                      (cell.content === undefined ||
                        cell.content === null ||
                        cell.content === '')
                    "
                  >
                  <span>-</span>
                  <!--<dean-spinner class="loader" quarter-circle></dean-spinner> -->
                </span>


                  <!-- CHECK IF OBJECT TYPE IS CURRENCY -->
                  <span v-if="cell.type == 'currency'">
                    <span class="currency" :align="cell.align">
                      {{ cell.content | currency }}
                    </span>
                  </span>

                  <!-- CHECK IF OBJECT TYPE IS EDIT -->
                  <span v-if="cell.type == 'edit'">
                    <dean-table-item
                      class="wrap"
                      :glyph="editIcon"
                      :href="cell.link"
                      :align="cell.align"
                      link
                    >
                      {{ cell.content }}
                    </dean-table-item>
                  </span>

                  <!-- CHECK IF OBJECT TYPE IS ID -->
                  <span v-if="cell.type == 'id' || cell.type == 'number'">
                    <dean-table-item
                      class="wrap"
                      :glyph="hashtagIcon"
                      :href="cell.link"
                      :align="cell.align"
                    >
                      {{ cell.content }}
                    </dean-table-item>
                  </span>

                  <!-- CHECK IF OBJECT TYPE IS DATE -->
                  <span v-if="cell.type == 'date'">
                    <dean-table-item
                      class="wrap"
                      :glyph="calendarMonthIcon"
                      :href="cell.link"
                      :align="cell.align"
                    >
                      {{ cell.content }}
                    </dean-table-item>
                  </span>

                  <!-- CHECK IF OBJECT TYPE IS STATUS -->
                  <span v-if="cell.type == 'status'">
                    <font
                      class="wrap"
                      :color="cell.content.color"
                      :align="cell.align"
                    >
                      <span>&bull;</span> {{ cell.content.text }}
                    </font>
                  </span>

                  <!-- CHECK IF OBJECT TYPE IS FINANCE -->
                  <span v-if="cell.type == 'finance'">
                    <dean-table-finance-bar
                      :data="cell.content"
                      :align="cell.align"
                    >
                    </dean-table-finance-bar>
                  </span>

                  <!-- CHECK IF OBJECT TYPE IS DOWNLOAD -->
                  <div v-if="cell.type == 'download'">
                    <div
                      class="download-icon"
                      v-for="(item, key) in cell.content"
                      :key="key"
                      @click="
                        deanTableCellDownloadClick($event, row, key, item.data)
                      "
                    >
                      <dean-tooltip v-if="item.link">
                        <a
                          slot="activator"
                          class="link"
                          :href="item.link"
                          :download="item.title"
                        >
                          <dean-table-item
                            class="glyph"
                            :glyph="item.icon"
                            height="25"
                            width="25"
                            link
                          ></dean-table-item>
                        </a>
                        {{ item.title }}
                      </dean-tooltip>
                      <dean-table-item
                        v-else
                        class="disabled"
                        :glyph="item.icon"
                        height="25"
                        width="25"
                      ></dean-table-item>
                    </div>
                  </div>

                  <!-- CHECK IF OBJECT TYPE IS ACTION -->
                  <div v-if="cell.type == 'action'">
                    <div
                      class="action-icon"
                      v-for="(item, key) in cell.content"
                      :key="key"
                      @click="
                        deanTableCellActionClick($event, row, key, item.data)
                      "
                    >
                      <dean-tooltip v-if="item.data">
                        <a slot="activator" class="link">
                          <dean-table-item
                            class="glyph"
                            :glyph="item.icon"
                            height="25"
                            width="25"
                            :link="true"
                          ></dean-table-item>
                        </a>
                        {{ item.title }}
                      </dean-tooltip>
                      <dean-table-item
                        v-else
                        class="disabled"
                        :glyph="item.icon"
                        height="25"
                        width="25"
                      />
                    </div>
                  </div>
                </span>
              </span>
              <!-- ELSE SHOW ITEM CONTENTS -->
              <span v-else>
                {{ cell }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from "vue";
import { Component, Inject, Prop, Watch, Emit } from "vue-property-decorator";
import VueCurrencyFilter from "vue-currency-filter";

Vue.use(VueCurrencyFilter, {
  symbol: "€",
  thousandsSeparator: ".",
  fractionCount: 2,
  fractionSeparator: ",",
  symbolPosition: "front",
  symbolSpacing: true,
});

//SVG
import archiveIcon from "../svg/feather-icons/archive.svg";
import emptyIcon from "../svg/icons/empty.svg";
import calendarMonthIcon from "../svg/feather-icons/calendar.svg";
import linkIcon from "../svg/feather-icons/link.svg";
import invoiceIcon from "../svg/icons/invoice.svg";
import detailsIcon from "../svg/feather-icons/eye.svg";
import editIcon from "../svg/feather-icons/edit-3.svg";
import messageIcon from "../svg/feather-icons/message-circle.svg";
import hashtagIcon from "../svg/feather-icons/hash.svg";
import pdfIcon from "../svg/icons/pdf.svg";
import csvIcon from "../svg/icons/csv.svg";
import summeryIcon from "../svg/feather-icons/list.svg";
import gridIcon from "../svg/feather-icons/grid.svg";

// COMPONENTS
import deanButton from "./deanButton.vue";
import deanButtonGroup from "./deanButtonGroup.vue";
import deanIcon from "./deanIcon.vue";
import deanTooltip from "./deanTooltip.vue";
import deanInputField from "./deanInputField.vue";
import deanTableItem from "./deanTableItem.vue";
import deanSpinner from "./deanSpinner.vue";
import deanTableFinanceBar from "./deanTableFinanceBar.vue";

@Component({
  components: {
    deanButton,
    deanButtonGroup,
    deanIcon,
    deanTooltip,
    deanInputField,
    deanTableItem,
    deanSpinner,
    deanTableFinanceBar,
  },
})

// CLASS
export default class deanTable extends Vue {
  // PROPS
  @Prop() data!: Array<any>;
  @Prop() columns!: object;
  @Prop({ default: false }) hover!: boolean;
  @Prop() subHeaders!: Array<string>;
  @Prop({default: true}) showLayoutButtons!: boolean;

  // DATA
  tableData: object | null = null;
  active: string = "string";
  click: boolean = false;
  gridView: boolean = false;
  activeColumn?: string;
  clickData = {
    cell: "",
    column: "",
    row: {},
  };

  // ICONS
  archiveIcon: object = archiveIcon;
  emptyIcon: object = emptyIcon;
  calendarMonthIcon: object = calendarMonthIcon;
  editIcon: object = editIcon;
  invoiceIcon: object = invoiceIcon;
  messageIcon: object = messageIcon;
  detailsIcon: object = detailsIcon;
  linkIcon: object = linkIcon;
  calendarIcon: object = calendarMonthIcon;
  hashtagIcon: object = hashtagIcon;
  pdfIcon: object = pdfIcon;
  csvIcon: object = csvIcon;
  summeryIcon: object = summeryIcon;
  gridIcon: object = gridIcon;

  // WATCHES
  @Watch("data")
  onDataChange() {
    this.processData();
  }

  @Watch("column")
  onTableSort(column: any, click: any) {
    this.deanTableColumnSort(column, click);
  }

  get view() {
    if (this.gridView == true) {
      return "grid-view";
    }
  }

  // METHODS
  viewButton(status) {
    if (status == true) {
      return "view-button active";
    } else {
      return "view-button";
    }
  }

  trClass(row: any) {
    let value = "";
    if (this.hover) value = `hover`;
    for (let item in row) {
      for (let header in this.subHeaders) {
        if (row[item].content == this.subHeaders[header]) {
          value = ` subHeader`;
        }
      }
    }
    return value;
  }

  checkIfHeader(row: any) {
    let value = false;
    for (let item in row) {
      for (let header in this.subHeaders) {
        if (row[item].content == this.subHeaders[header]) {
          value = true;
        }
      }
    }
    return value;
  }

  checkTableData(data: any) {
    if (
      data == undefined ||
      data == null ||
      data == 0 ||
      data == "" ||
      data == {} ||
      data == []
    ) {
      return true;
    }
  }

  checkRowType(type: any) {
    if (
      type == undefined ||
      type == null ||
      type == 0 ||
      type == "" ||
      type == "default"
    ) {
      return true;
    }
  }

  checkColumnType(value: any) {
    if (value == true) {
      return true;
    } else {
      return false;
    }
  }

  deanTableColumnSort(column: any, click: any) {
    if (this.active === column.dql) {
      if (this.click === true) {
        return "arrow asc";
      } else {
        return "arrow dsc";
      }
    } else {
      return "arrow default";
    }
  }

  deanTableColumnClick(column: any, click: any) {
    console.log(this.active);
    let sort = "";
    if (this.active === column.dql) {
      if (this.click === true) {
        sort = "";
        this.click = !this.click;
      } else {
        sort = "-";
        this.click = !this.click;
      }
    } else {
      sort = "-";
      this.active = column.dql;
      this.click = true;
    }
    this.$emit("column-click", column, sort);
  }

  deanTableCellClick(cell: any, column: any) {
    console.log("deanTableCellClick");
    this.clickData.cell = cell;
    this.clickData.column = column;
  }

  deanTableRowClick(row: any) {
    console.log("deanTableRowClick");
    this.clickData.row = row;
    this.$emit("cell-click", this.clickData);
  }

  deanTableCellDownloadClick(event: any, row: any, key: any, data: any) {
    event.stopPropagation();
    let downloadClick = {
      row: row,
      key: key,
      data: data,
    };
    this.$emit("download-click", downloadClick);
  }

  deanTableCellActionClick(event: any, row: any, key: any, data: any) {
    event.stopPropagation();
    let actionClick = {
      row: row,
      key: key,
      data: data,
    };
    this.$emit("action-click", actionClick);
  }

  processData() {
    let data = JSON.parse(JSON.stringify(this.data));
    for (let row in data) {
      if (Object.prototype.hasOwnProperty.call(data, row)) {
        for (let cell in data[row]) {
          if (Object.prototype.hasOwnProperty.call(data[row], cell)) {
            let columns: any = this.columns;

            if (columns[cell] == (undefined && null && "")) {
              delete data[row][cell];
            } else {
              if (columns[cell].type == (undefined && null && "")) {
                columns[cell].type = "default";
              }

              if (columns[cell].align == (undefined && null && "")) {
                columns[cell].align = "left";
              }

              if (columns[cell].slot == (undefined && null && "")) {
                columns[cell].slot = "none";
              }

              if (columns[cell].tooltip == (undefined && null && "")) {
                columns[cell].tooltip = false;
              }

              if (columns[cell].icon == (undefined && null && "")) {
                columns[cell].icon = emptyIcon;
              }

              let updatedCell = {
                title: columns[cell].content,
                content: data[row][cell],
                type: columns[cell].type,
                slot: columns[cell].slot,
                align: columns[cell].align,
                tooltip: columns[cell].tooltip,
                icon: columns[cell].icon,
              };

              data[row][cell] = updatedCell;
            }
          }
        }
      }
    }
    this.tableData = data;

    console.log(this.tableData);
    console.log(this.data);
  }

  created() {
    this.processData();
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import "../scss/vars";

.no-data {
  @include display-flex();
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
  font-weight: 700;
  color: var(--color-light-shade-1, $color-light-shade-1);
  padding: 20px;

  .no-data-text {
    text-align: center;
    width: 100%;
    display: block;
    font-size: 15pt;
    line-height: 1;
    padding-bottom: 20px;
    word-break: keep-all;
    @media #{$medium} {
      font-size: 15pt;
    }
  }

  .no-data-icon {
    @include display-flex();
    justify-content: center;
    width: 80%;
    fill: var(--color-light-shade-2, $color-light-shade-2);
    @media #{$medium} {
      width: 5%;
    }
  }
}

// DEAN TABLE
.dean-table {
  padding: 10px;

  .view-buttons {
    @include display-flex();
    width: 100%;
    align-items: center;
    justify-content: flex-end;

    @media #{$small-only} {
      display: none;
    }

    .view-button {
      width: 25px;
      padding: 5px;
      cursor: pointer;
      fill: var(--color-dark-shade-3, $color-dark-shade-3);
      &:hover {
        fill: var(--color-dark $color-dark);
      }
    }
    .active {
      fill: var(--color-dark, $color-dark);
    }
  }

  table {
    border-collapse: collapse;
    margin: 0;
    padding: 0;
    min-width: 100%;
    overflow-wrap: break-word;
    @include hyphens(auto);

    a {
      color: black;
    }

    tr {
      padding: 10px;
    }

    .hover {
      cursor: pointer;
      @media #{$medium} {
        &:hover {
          $hover: var(--color-light-shade-4, $color-light-shade-4);
          background: $hover;
          /*
          td {
            border-bottom: 1px solid $hover;
            border-right: 4px solid $hover;
            border-left: 4px solid $hover;

            &:first-child {
              border-left: 0px;
              // border-right: 4px solid $hover;
            }

            &:last-child {
              border-left: 4px solid $hover;
              border-right: 0px;
            }
          } */
        }
      }
    }

    @media #{$medium} {
      .subHeader td {
        font-weight: 700 !important;
        //background: var(--color-light-shade-4, $color-light-shade-4);
        border-bottom: 1.5px solid var(--color-light, $color-light) !important;
        // border-bottom: 1px solid var(--color-secondary, $color-secondary);
      }
    }

    th {
      font-weight: 400;
      font-weight: normal;
      @include table-row-height;
      padding: 10px;
      background: var(--color-light-shade-2, $color-light-shade-2);
      border-right: 4px solid white;
      border-left: 4px solid white;
      @include border-radius(10px 10px 0 0);
      //text-transform: lowercase;
      /*
        &:first-letter {
          text-transform: uppercase;
        }
        */

      &:first-child {
        border-left: 0px;
        border-right: 4px solid white;
      }

      &:last-child {
        border-left: 4px solid white;
        border-right: 0px;
      }

      .active .arrow {
        opacity: 1;
      }
    }

    .sort {
      display: block;
      width: 100%;
      cursor: pointer;
      @include text-select-none();
    }

    td {
      padding: 5px 10px 5px 10px;
      border-bottom: 1px solid var(--color-light-shade-3, $color-light-shade-3);
      border-right: 4px solid white;
      border-left: 4px solid white;
      @include table-row-height;

      &:first-child {
        border-left: 0px;
        border-right: 4px solid white;
      }

      &:last-child {
        border-left: 4px solid white;
        border-right: 0px;
      }

      .link {
        display: block;
        height: 100%;
        width: 100%;
        color: var(--color-link, $color-link);
        cursor: pointer;
        text-decoration: none;
      }

      .active {
        color: var(--color-info-success, $color-info-success);
        font-weight: 700;

        &::before {
          @include small-circle-left($color-info-success);
        }
      }

      .inactive {
        color: var(--color-info-standard, $color-info-standard);
        font-weight: 700;

        &::before {
          @include small-circle-left($color-info-warning);
        }
      }

      .suspended {
        color: var(--color-info-danger, $color-info-danger);
        font-weight: 700;

        &::before {
          @include small-circle-left(
            var(--color-info-danger, $color-info-danger)
          );
        }
      }
    }

    /*
      caption {
        font-size: 1.5em;
        margin: 0.5em 0 0.75em;
      }
      */
    .dean-tool-tip-content {
      padding: 3px;
    }
  }

  .action-icon,
  .download-icon {
    display: inline-block;
  }

  .disabled {
    cursor: default;
  }

  .arrow {
    display: inline-block;
    vertical-align: middle;
    width: 0;
    height: 0;
    margin-left: 5px;
  }

  .arrow-empty {
    border-right: 4px solid transparent;
    border-left: 4px solid transparent;
    border-top: 4px solid transparent;
  }

  .arrow.default {
    border-right: 4px solid transparent;
    border-left: 4px solid transparent;
    border-top: 4px solid transparent;

    &:before {
      display: block;
      position: absolute;
      margin: -8px 0px 0px -5px;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-bottom: 4px solid rgba(0, 0, 0, 0.2);
      content: "";
    }

    &:after {
      display: block;
      position: absolute;
      margin: -2px 0px 0px -5px;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 4px solid rgba(0, 0, 0, 0.2);
      content: "";
    }
  }

  .arrow.asc {
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-bottom: 4px solid var(--color-dark-shade-4, $color-dark-shade-4);
  }

  .arrow.dsc {
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 4px solid var(--color-dark-shade-4, $color-dark-shade-4);
  }

  .center {
    @include display-flex();
    align-items: center;
    justify-content: center;
  }

  .left {
    @include display-flex();
    align-items: center;
    justify-content: flex-start;
  }

  .right {
    @include display-flex();
    align-items: center;
    justify-content: flex-end;
  }

  @mixin gridView() {
    table {
      border: 0;
      paddng: 0;

      tbody {
        @include display-flex;
        flex-wrap: wrap;
        width: 100%;
      }

      thead {
        border: none;
        clip: rect(0 0 0 0);
        height: 1px;
        margin: -1px;
        padding: 0;
        position: absolute;
        width: 1px;
      }

      tr {
        display: block;
        padding: 0;
        justify-content: flex-start;
        @include border-radius(10px);
        @include box-shadow(0px 3px 5px rgba(0, 0, 0, 0.075));
        padding-bottom: 10px;
        margin: 5px;
        @include calc("width", "25% - 10px");
        @media #{$large-only} {
          @include calc("width", "33.33333333333% - 10px");
        }
        @media #{$medium-only} {
          @include calc("width", "50% - 10px");
        }
        @media #{$small-only} {
          width: 100%;
          margin: 0px 0px 20px 0px;
        }
      }

      th {
        border-left: 0;
        border-right: 0;
        padding: 15px;
      }

      td {
        border-bottom: 1px solid
          var(--color-light-shade-3, $color-light-shade-3);
        display: flex;
        width: 100%;
        padding: 15px;
        border-left: 0;
        border-right: 0;
        text-align: right;
        max-width: 100%;
        justify-content: space-between;

        &:first-child {
          background: var(--color-light-shade-2, $color-light-shade-2);
          @include border-radius(10px 10px 0px 0px);
          border: 0;

          &:before {
            /** aria-label has no advantage, it won't be read inside a table
              content: attr(aria-label);*/
            content: attr(data-label);
            float: left;
          }
        }

        &:before {
          /** aria-label has no advantage, it won't be read inside a table
            content: attr(aria-label);*/
          content: attr(data-label);
          float: left;
        }

        &:last-child {
          border: 0;
          @include border-radius(0 0 10px 10px);
        }
      }

      .wrap {
        display: block;
        max-width: 50%;
        white-space: nowrap; /* Don't forget this one */
        @media #{$small-only} {
          max-width: 200px;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }

      .loader {
        display: block;
        margin-right: 0;
        text-align: right;
      }
    }

    .action-icon,
    .download-icon {
      display: inline-block;
    }
  }

  .grid-view {
    @include gridView();
  }

  @media #{$small-only} {
    @include gridView();
  }
}
</style>
